// import React from "react";
// import {
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Checkbox,
//   Box,
//   Divider,
//   Chip,
// } from "@mui/material";

// export default function TasksReminders({ tasks = [], onToggle = () => {} }) {
//   const hasTasks = Array.isArray(tasks) && tasks.length > 0;

//   const isOverdue = (task) => {
//     if (!task?.due || task.done) return false;
//     const due = new Date(task.due);
//     if (Number.isNaN(due.getTime())) return false;
//     return due.getTime() < Date.now();
//   };

//   const formatDue = (task) => {
//     if (!task?.due) return null;
//     const d = new Date(task.due);
//     if (Number.isNaN(d.getTime())) return null;
//     return d.toLocaleDateString(undefined, {
//       month: "short",
//       day: "numeric",
//     });
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           mb: 1.5,
//           display: "flex",
//           alignItems: { xs: "flex-start", sm: "center" },
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: 11,
//               letterSpacing: 0.8,
//               textTransform: "uppercase",
//               color: "text.secondary",
//             }}
//           >
//             Tasks
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: 700, lineHeight: 1.2 }}
//           >
//             Tasks & Reminders
//           </Typography>
//         </Box>
//         {hasTasks && (
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {tasks.filter((t) => !t.done).length} open / {tasks.length} total
//           </Typography>
//         )}
//       </Box>

//       <Divider sx={{ mb: 1.5 }} />

//       {/* Content */}
//       {!hasTasks ? (
//         <Box
//           sx={{
//             py: 3,
//             textAlign: "center",
//             color: "text.secondary",
//             fontSize: 14,
//           }}
//         >
//           No tasks.
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             flex: 1,
//             overflowY: "auto",
//             maxHeight: { xs: 220, sm: 260, md: 300 },
//           }}
//         >
//           <List dense disablePadding>
//             {tasks.map((task) => {
//               const overdue = isOverdue(task);
//               const dueLabel = formatDue(task);

//               return (
//                 <ListItem
//                   key={task.id}
//                   sx={{
//                     px: 0,
//                     py: 0.75,
//                     alignItems: "flex-start",
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid",
//                       borderColor: "rgba(229,231,235,0.6)",
//                     },
//                   }}
//                 >
//                   <Checkbox
//                     edge="start"
//                     size="small"
//                     checked={!!task.done}
//                     onChange={() => onToggle(task.id)}
//                     sx={{ mr: 1 }}
//                   />
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontWeight: 500,
//                           textDecoration: task.done
//                             ? "line-through"
//                             : "none",
//                           color: task.done
//                             ? "text.disabled"
//                             : "text.primary",
//                         }}
//                       >
//                         {task.description}
//                       </Typography>
//                     }
//                     secondary={
//                       (dueLabel || overdue || task.priority) && (
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 0.75,
//                             mt: 0.25,
//                             flexWrap: "wrap",
//                           }}
//                         >
//                           {dueLabel && (
//                             <Typography
//                               variant="caption"
//                               sx={{ color: "text.secondary" }}
//                             >
//                               Due {dueLabel}
//                             </Typography>
//                           )}
//                           {overdue && (
//                             <Chip
//                               label="Overdue"
//                               size="small"
//                               sx={{
//                                 height: 20,
//                                 fontSize: 11,
//                                 borderRadius: 999,
//                                 bgcolor: "rgba(239,68,68,0.10)",
//                                 color: "#B91C1C",
//                               }}
//                             />
//                           )}
//                           {task.priority && (
//                             <Chip
//                               label={task.priority}
//                               size="small"
//                               sx={{
//                                 height: 20,
//                                 fontSize: 11,
//                                 borderRadius: 999,
//                                 bgcolor: "rgba(59,130,246,0.08)",
//                                 color: "#1D4ED8",
//                                 textTransform: "capitalize",
//                               }}
//                             />
//                           )}
//                         </Box>
//                       )
//                     }
//                     secondaryTypographyProps={{ component: "div" }}
//                   />
//                 </ListItem>
//               );
//             })}
//           </List>
//         </Box>
//       )}
//     </Paper>
//   );
// }

import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function TasksReminders({ tasks = [], onToggle = () => {} }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const accent = dark ? "#fb923c" : "#f97316";

  const hasTasks = Array.isArray(tasks) && tasks.length > 0;

  const isOverdue = (task) => {
    if (!task?.due || task.done) return false;
    const due = new Date(task.due);
    if (Number.isNaN(due.getTime())) return false;
    return due.getTime() < Date.now();
  };

  const formatDue = (task) => {
    if (!task?.due) return null;
    const d = new Date(task.due);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          mb: 1.75,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: muted,
              fontWeight: 500,
              fontFamily:
                '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            }}
          >
            Tasks
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              fontWeight: 800,
              fontSize: "1.35rem",
              lineHeight: 1.15,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Tasks & Reminders
          </Typography>
        </Box>

        {hasTasks && (
          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
              whiteSpace: "nowrap",
            }}
          >
            {tasks.filter((t) => !t.done).length} open / {tasks.length} total
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 1.5, borderColor: border }} />

      {!hasTasks ? (
        <Box
          sx={{
            py: 3,
            textAlign: "center",
            color: mid,
            fontSize: 14,
          }}
        >
          No tasks.
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            maxHeight: { xs: 220, sm: 260, md: 300 },
          }}
        >
          <List dense disablePadding>
            {tasks.map((task) => {
              const overdue = isOverdue(task);
              const dueLabel = formatDue(task);

              return (
                <ListItem
                  key={task.id}
                  sx={{
                    px: 0,
                    py: 0.85,
                    alignItems: "flex-start",
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <Checkbox
                    edge="start"
                    size="small"
                    checked={!!task.done}
                    onChange={() => onToggle(task.id)}
                    sx={{
                      mr: 1,
                      color: alpha(accent, 0.65),
                      "&.Mui-checked": {
                        color: accent,
                      },
                    }}
                  />

                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          textDecoration: task.done ? "line-through" : "none",
                          color: task.done ? muted : text,
                          lineHeight: 1.6,
                        }}
                      >
                        {task.description}
                      </Typography>
                    }
                    secondary={
                      (dueLabel || overdue || task.priority) && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.75,
                            mt: 0.45,
                            flexWrap: "wrap",
                          }}
                        >
                          {dueLabel && (
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: mid,
                              }}
                            >
                              Due {dueLabel}
                            </Typography>
                          )}

                          {overdue && (
                            <Chip
                              label="Overdue"
                              size="small"
                              sx={{
                                height: 22,
                                fontSize: 11,
                                fontWeight: 700,
                                borderRadius: 999,
                                bgcolor: dark
                                  ? "rgba(239,68,68,0.18)"
                                  : "rgba(239,68,68,0.10)",
                                color: dark ? "#fca5a5" : "#B91C1C",
                                border: `1px solid ${
                                  dark
                                    ? "rgba(239,68,68,0.24)"
                                    : "rgba(239,68,68,0.18)"
                                }`,
                              }}
                            />
                          )}

                          {task.priority && (
                            <Chip
                              label={task.priority}
                              size="small"
                              sx={{
                                height: 22,
                                fontSize: 11,
                                fontWeight: 700,
                                borderRadius: 999,
                                bgcolor: dark
                                  ? alpha(accent, 0.14)
                                  : alpha(accent, 0.08),
                                color: accent,
                                border: `1px solid ${alpha(accent, 0.2)}`,
                                textTransform: "capitalize",
                              }}
                            />
                          )}
                        </Box>
                      )
                    }
                    secondaryTypographyProps={{ component: "div" }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Paper>
  );
}